const selectIsLoading = (state) => state.loading.isLoading;

export default {selectIsLoading};